<template>
  <div>
    <!--Objetivos estratégicos-->
    <div class="row listObjetivos">
      <div
        class="divObjetivo"
        v-for="objetivo in arrayObjetivosEstrategicos"
        v-bind:key="objetivo.id"
      >
        <Objetivo
          :objetivo="objetivo"
          :objetivoSelected="objetivo.selected"
          :form_dirty="form_dirty"
          @updateVisibility="refreshObjetivoVisibility"
        />
      </div>
    </div>
    <!--Nombre del objetivo, solo se pinta si el objetivo está seleccionado-->
    <div v-if="nameObjetivo !== null" class="divNameObjetivo">
      <span class="title col self-center" :style="colorFondo">
        {{ prefixObjetivo }}: {{ nameObjetivo }}
      </span>
      <span class="triangle" :style="colorTriangulo"></span>
    </div>

    <!--Objetivos especificos-->
    <div v-if="nameObjetivo !== null">
      <h2 class="subTitleCard marginTop">Objetivos específicos</h2>
      <h1 class="textObjetivoEspecifico">
        Seleccione Objetivo específico o cree uno para ver sus indicadores y
        realizar acciones
      </h1>
      <div v-if="arrayObjetivosEspecificos.length > 0" class="row">
        <div
          class="col-4 divObjetivoEspecifico"
          v-for="objetivoEspecifico in arrayObjetivosEspecificos"
          v-bind:key="objetivoEspecifico.id"
        >
          <ObjetivoEspecifico
            :objetivoEspecifico="objetivoEspecifico"
            :color="colorFondo.backgroundColor"
            :colorHover="colorHover.backgroundColor"
            :objetivoEspecificoSelected="objetivoEspecifico.selected"
            :form_dirty="form_dirty"
            @updateVisibilityEspecificos="refreshObjetivoEspecificoVisibility"
          />
        </div>
      </div>

      <!--indicadores-->
      <div v-if="objetivoEspecificoSelected">
        <Indicadores
          :idObjetivoSelected="idObjetivosEspecificoSeleccionado"
          :idObjetivoEstategico="idObjetivoEstrategico"
          :form_dirty="form_dirty"
          @updateDirtyForm ="refreshDirtyForm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Objetivo from '@/components/PlanAccion/components/Objetivo.vue';
import ObjetivoEspecifico from '@/components/PlanAccion/components/ObjetivoEspecifico.vue';
import Indicadores from '@/components/PlanAccion/components/Indicadores.vue';
import Vue from 'vue';
import * as types from '@/storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';

export default {
  components: {
    Objetivo,
    ObjetivoEspecifico,
    Indicadores
  },
  props: {
    arrayObjetivos: Array
  },
  mixins: [Loading],
  data () {
    return {
      colorFondo: {
        backgroundColor: `${this.arrayObjetivos[0].color}`
      },
      colorTriangulo: {
        borderBottomColor: `${this.arrayObjetivos[0].color}`
      },
      colorHover: {
        backgroundColor: `${this.arrayObjetivos[0].color}`
      },
      nameObjetivo: null,
      idObjetivoEstrategico: null,
      arrayObjetivosEspecificos: [],
      objetivoEspecificoSelected: false,
      idObjetivosEspecificoSeleccionado: '',
      arrayObjetivosEstrategicos: [],
      form_dirty: false
    };
  },
  created () {
    this.arrayObjetivosEstrategicos = [...this.arrayObjetivos];
    this.arrayObjetivosEstrategicos.forEach(objetivo => {
      objetivo['selected'] = false;
    });
  },
  mounted () {
    this.$eventHub.$on('dirtyForm', acciones => {
      this.form_dirty = true;
    });
    this.$eventHub.$on('cleanForm', acciones => {
      this.form_dirty = false;
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('dirtyForm');
    this.$eventHub.$off('cleanForm');
  },
  methods: {
    refreshObjetivoVisibility (objetivoDatos) {
      this.form_dirty = false;
      this.objetivoEspecificoSelected = false;
      this.nameObjetivo = objetivoDatos.nameObj;
      this.prefixObjetivo = objetivoDatos.prefixObj;
      this.colorFondo.backgroundColor = objetivoDatos.colorObj;
      this.colorTriangulo.borderBottomColor = objetivoDatos.colorObj;
      this.idObjetivoEstrategico = objetivoDatos.idObj;
      this.colorHover.backgroundColor = objetivoDatos.colorHoverObj;
      this.arrayObjetivosEstrategicos.map(objetivo => {
        if (objetivo.id !== objetivoDatos.idObj) {
          objetivo['selected'] = false;
        } else {
          objetivo['selected'] = true;
        }
      });
      this.getObjetivosEspecificos();
    },
    getObjetivosEspecificos () {
      this.showLoading();
      this.$store
        .dispatch(types.ACTION_GET_OBJETIVOS_ESPECIFICOS, {
          idObjetivo: this.idObjetivoEstrategico
        })
        .then(response => {
          this.hideLoading();
          this.arrayObjetivosEspecificos = response.data;
        })
        .catch(() => {
          this.hideLoading();
        });
    },
    refreshObjetivoEspecificoVisibility (objetivoDatos) {
      this.form_dirty = false;
      this.objetivoEspecificoSelected = true;
      this.idObjetivosEspecificoSeleccionado = objetivoDatos.idObj;
      this.arrayObjetivosEspecificos.map(objetivoEspecifico => {
        if (objetivoEspecifico.id !== objetivoDatos.idObj) {
          Vue.set(objetivoEspecifico, 'selected', false);
        } else {
          Vue.set(objetivoEspecifico, 'selected', true);
        }
      });
    },
    refreshDirtyForm () {
      this.form_dirty = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.listObjetivos {
  display: flex;
  justify-content: space-between;
  padding-top: 30px;
  padding-bottom: 30px;
  align-items: center;
}
.triangle {
  border-bottom: 70px solid transparent;
  border-right: 40px solid transparent;
  margin: 4px 0;
  padding: 0;
  left: -4px;
  height: 70px;
  position: relative;
}
.title {
  align-items: center;
  border: 0;
  display: flex;
  font-size: 14px;
  font-weight: bold;
  height: 70px;
  margin: 4px 4px 4px 0px;
  padding: 2px 2px 2px 20px;
  position: relative;
  text-align: left;
  transition: all 0.2s ease;
  transition: background-color 0.3s;
  transition: box-shadow 2s;
  transition: width 0.5s;
  z-index: 1;
  color: #4c4c4c;
}
.divNameObjetivo {
  display: flex;
  width: 40%;
}
.marginTop {
  margin-top: 20px;
}
.textObjetivoEspecifico {
  font-family: DINPro;
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.22px;
  color: #4e5768;
  margin: 5px 0px 35px 4px !important;
}
.divObjetivo {
  display: flex;
  height: 70px;
  width: 70px;
  align-items: center;
  justify-content: center;
}
.divObjetivoEspecifico {
  padding: 15px 15px 15px 0px;
}
</style>
